import { CommonModule } from "@angular/common";
import { Component, EventEmitter, OnDestroy, OnInit, Output, inject } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { UtilsMsoService } from "@mso-services/utilsMso.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ErrorDecoupling } from "@providers/DecouplingUserServiceMSO.service";
import { Utils } from "@utils/Utils";
import { Subject, takeUntil } from "rxjs";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "card-personal-data-protection-policy-form",
  templateUrl: "./card-personal-data-protection-policy-form.html",
  styleUrls: ["./card-personal-data-protection-policy-form.scss"],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule, ReactiveFormsModule],
})
export class CardPersonalDataProtectionPolicyFormComponent implements OnInit, OnDestroy {
  @Output() policyAccepted: EventEmitter<boolean> = new EventEmitter();
  formGroup: FormGroup;
  headLabel: string;
  contentLabelInit: string;
  policyPdfLink: string;
  contentLabelEnd: string;
  url: string;
  hash: string;
  code: string;

  private translate = inject(TranslateService);
  private utilsMsoService = inject(UtilsMsoService);
  private formBuilder = inject(FormBuilder);
  public utils = inject(Utils);

  private readonly unsubscribe$ = new Subject();

  constructor() {
    this.formGroup = this.formBuilder.group({
      tycCheck: [false, [Validators.required, Validators.requiredTrue]],
    });
    this.headLabel = this.translate.instant("popuptycselfietitle");
    this.contentLabelInit = this.translate.instant("popuptycselfietx01");
    this.contentLabelEnd = this.translate.instant("popuptycselfietx03");
    this.policyPdfLink = this.translate.instant("popuptycselfietx02");
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {
    this.utilsMsoService
      .getLastTermsAndConditionsSelfie("Nacional")
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.code = data.Code;
        this.url = data.Url;
        this.hash = data.Hash;
      });
  }

  submit() {
    const isDecoupling = this.utils.globalVars.FEATURES.MSO_TermsAndConditionsSelfie_Decoupling;
    if (!isDecoupling) {
      this.utils.loader();
    }

    this.utilsMsoService
      .updateTermsAndConditionsSelfie()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (_) => {
          if (!isDecoupling) {
            this.utils.closeLoader();
          }
          this.policyAccepted.emit(true);
          this.formGroup.reset();
        },
        error: (err) => {
          let msg = "";
          if (!isDecoupling) {
            this.utils.closeLoader();
            const { message } = err;
            msg = message;
          } else {
            const { description } = err as ErrorDecoupling;
            msg = description ?? "";
          }
          this.utils.showError(msg);
        },
      });
  }
}
